<nb-select fullWidth
           [(selected)]="value"
           [placeholder]="'Technische Einrichtung auswählen'"
           [disabled]="isDisabled">
  <nb-option *ngIf="showEmptyOption" [value]="null">Alle</nb-option>
  <nb-option *ngFor="let facilityElement of facilityElements"
             [value]="facilityElement">{{ facilityElement | facilityElementTranslation }}</nb-option>
</nb-select>
